import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Reprovar", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Aprovar", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-alinhar-itens-centro" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-6 ss-alinhar-centro" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "ss-imagem-responssiva",
      width: "120",
      src: "/static/img/ilustracoes/curadoria-centro-inteligencia.png",
      alt: "Centro de Inteligência - Curadoria"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-18" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "ss-mensagem-informativa" }, [
      /*#__PURE__*/_createTextVNode("O cadastro de Estados é atualizado constantemente por uma "),
      /*#__PURE__*/_createElementVNode("b", null, "central de inteligência do NeoX"),
      /*#__PURE__*/_createTextVNode(", deixando tudo em conformidade com os órgãos responsáveis para que você possa ter a melhor experiência possível. Mas se você necessita de um Estado que não está disponível preencha as informações abaixo e clique em: "),
      /*#__PURE__*/_createElementVNode("b", null, "\"Sugerir cadastro\""),
      /*#__PURE__*/_createTextVNode(".")
    ])
  ])
], -1)
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-20 ant-col-xl-15" }
const _hoisted_11 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-5" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_icone = _resolveComponent("icone")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_pais = _resolveComponent("selecionar-pais")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-cadastros"
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Cadastro de Estados "),
        ((!_ctx.state.aplicarRegrasEnvioCuradoria))
          ? (_openBlock(), _createBlock(_component_a_switch, {
              key: 0,
              checked: _ctx.state.estado.ativo,
              "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.estado.ativo) = $event)),
              style: {"float":"right"},
              "checked-children": "Ativo",
              "un-checked-children": "Inativo"
            }, null, 8, ["checked"]))
          : _createCommentVNode("", true)
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        ((_ctx.state.aplicarRegrasRevisaoCuradoria))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-secondary",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reprovarCadastro()))
              }, _hoisted_3),
              _createElementVNode("button", {
                type: "button",
                class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.aprovarCadastro()))
              }, _hoisted_5)
            ]))
          : ((_ctx.state.aplicarRegrasEnvioCuradoria))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.salvar(false)))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                ((_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir && _ctx.telaBase.permissaoDados.incluir)
                    || (_ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar && _ctx.telaBase.permissaoDados.alterar))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-lg ant-btn-secondary",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.salvar(true)))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvarNovo), 1)
                      ]),
                      _createElementVNode("button", {
                        type: "button",
                        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.salvar(false)))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.modalBase.textoBotaoSalvar), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando
        }, {
          default: _withCtx(() => [
            ((_ctx.state.aplicarRegrasEnvioCuradoria && _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Incluir))
              ? (_openBlock(), _createBlock(_component_card, { key: 0 }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_a_form_item, {
                      label: "Nome",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "250",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.estado.nome) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.estado.nome]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_form_item, {
                      label: "Sigla",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "2",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.estado.sigla) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.estado.sigla]
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_a_form_item, {
                      label: "Código IBGE",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          maxlength: "10",
                          class: "ant-input",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.estado.codigoIbge) = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.estado.codigoIbge]
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, {
                      label: "País",
                      class: "ss-margin-campos",
                      rules: [{ required: true }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_pais, {
                          codigoSelecionado: _ctx.state.estado.codigoPais,
                          "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.estado.codigoPais) = $event)),
                          placeholder: "Digite para selecionar um país"
                        }, null, 8, ["codigoSelecionado"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}